import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";

const PushNotificationsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("push_notifications.details"),
            editBtn: false,
            deleteBtn: false,
            data: {
              images: details?.image && [{ id: 0, img: details?.image }],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data,
            listTitle: t("push_notifications.title"),
            createBtnTitle: t("push_notifications.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "notificationEN",
                Header: t("push_notifications.notification_message_en"),
              },
              {
                accessor: "notificationAR",
                Header: t("push_notifications.notification_message_ar"),
              },
              { accessor: "sent_at", Header: t("details.created_at") },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("push_notifications.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(t),
            validationSchema: validationSchema(t),
            deleteFun: deleteFun,
            title: t("push_notifications.add"),
            submitTitle: t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default PushNotificationsTemplate;
